// Devolvemos TRUE si el rol del usuario está en la lista de roles permitidos.
export const isRoleAllowed = (rolesAllowed: string[], currentRole?: string | null): boolean => {
    if (!currentRole) return false;
    else return rolesAllowed.includes(currentRole);
};